(function () {
    const buttons = document.querySelectorAll(".missionProject__openModal");
    const modal = document.getElementById('donationModal');

    for (const button of buttons) {
        const destination = button.dataset.destination;
        const title = button.dataset.title
        button.addEventListener("click", () => {
            modal.querySelector('#donationForm__title').textContent = title;
            modal.querySelector(
                '#donationForm__destination'
            ).value = destination;
            modal.classList.add('active');
        })
    }
})();